import React, { useState } from "react";
import ImageLoader from "../../Common/ImageLoader";
import RatingStar from "../../Common/RatingStar";
import { composeArrayForRatings } from "../../Common/CommonMethods";
import { Link } from "react-router-dom";

const hideShowContent = (event) => {
  event.preventDefault();
  const contentShowHide = document.querySelector(".showLessMoreContent");
  const hiddenItems = Array.prototype.slice.call(
    document.querySelectorAll(".contentHide")
  );

  const showing = contentShowHide.textContent === "Show more";

  hiddenItems.forEach(function (item) {
    if (!showing) {
      item.classList.add("content-hidden");
    } else {
      item.classList.remove("content-hidden");
    }

    contentShowHide.textContent =
      contentShowHide.textContent === "Show more" ? "Show Less" : "Show more";
  });
};

const SponsoredBox = (props) => {
  const [isShowMore, setShowMore] = useState(false);
  const getWordsToDisplay = (desc) => {
    //get total words
    let totalWords = desc.split(" ");
    let range = 225;
    let charactercount = 0;
    let idx = 0;

    for (let word = 0; word < totalWords.length; word++) {
      charactercount += totalWords[word].length + 1;
      if (charactercount >= range) {
        idx = word;
        break;
      }
    }
    //setDescIndex(idx);
    return {
      visble: totalWords.slice(0, idx),
      hidden: totalWords.slice(idx),
    };
  };

  return (
    <>
      <div className="vendor_profile_sponsored_bottom_content_block">
        <div className="single_column_block">
          <ul>
            <li>
              <div className="left">
                <span className="badge_content sponsoredBadgeContent">
                  Sponsored Content
                </span>
                <div className="logo_block">
                  <ImageLoader
                    image={props.sponsored.logo}
                    fallbackImage={"/static/images/FC-Generic-Logo.webp"}
                    width={115}
                    height={90}
                  />
                </div>
                <div className="content_block">
                  <span className="heading_txt">About</span>
                  <p>
                    <span className="content_open">
                      {props.sponsored.description.length > 225
                        ? !!props.sponsored &&
                          !!props.sponsored.description &&
                          getWordsToDisplay(
                            props.sponsored.description
                          ).visble.join(" ")
                        : !!props.sponsored &&
                          !!props.sponsored.description &&
                          getWordsToDisplay(
                            props.sponsored.description
                          ).hidden.join(" ")}
                    </span>
                    {isShowMore ? (
                      <span className="item contentHide ">
                        {` ${
                          !!props.sponsored &&
                          !!props.sponsored.description &&
                          getWordsToDisplay(
                            props.sponsored.description
                          ).hidden.join(" ")
                        }`}
                      </span>
                    ) : (
                      ``
                    )}
                    {props.sponsored.description.length > 225 ? (
                      <a
                        href="#show more"
                        className="showLessMoreContent"
                        onClick={(e) => {
                          //hideShowContent(e);
                          e.preventDefault();
                          setShowMore(!isShowMore);
                        }}
                      >
                        {isShowMore ? `Show Less` : `Show more`}
                      </a>
                    ) : (
                      ``
                    )}
                  </p>
                </div>
              </div>
              <div className="right">
                {!!props.sponsored?.rating &&
                  Object.keys(props.sponsored.rating).length > 0 && (
                    <div className="starRatingContentBlock">
                      <span className="heading_txt">Rating</span>
                      <div className="ratingContentBlock">
                        <RatingStar
                          starCount={composeArrayForRatings(
                            props.sponsored.rating.aggregate_score
                          )}
                          withoutO
                          inline
                        />
                        <div className="totalRating">
                          <span className="rating">{`${props.sponsored.rating.aggregate_score}/5.0`}</span>
                          <span className="all_rating">
                            {" "}
                            ({props.sponsored.rating.rated_by_user_count})
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                <div className="SponsoredBlockCustomerReferences">
                  <span className="heading_txt">{`${props?.sponsored?.name} Customer References`}</span>
                  <ul>
                    <li className="caseStudies">
                      <span className="number">
                        {props.sponsored.casestudy_count}
                      </span>
                      <span className="txt">Case Studies</span>
                    </li>
                    <li className="videos">
                      <span className="number">
                        {props.sponsored.video_count}
                      </span>
                      <span className="txt">Videos</span>
                    </li>
                    <li className="testimonials">
                      <span className="number">
                        {props.sponsored.testimonial_count}
                      </span>
                      <span className="txt">Testimonials</span>
                    </li>
                  </ul>
                  <div className="btn_visit_profile">
                    <Link to={props.sponsored.profile_url}>Visit profile</Link>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SponsoredBox;
